/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Merge selected events" |
*
* @param {Merge_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_aria_label = /** @type {((inputs?: Merge_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner les evenements selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse zusammenführen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединить выбранные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并选定事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを結合する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं को मर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mesclar eventos selecionados")
	return /** @type {LocalizedString} */ ("Merge selected events")
});